export const columnsConfig = {
    pending_ads: [
        { key: "sales_person", label: "Sales Person Details" },
        { key: "created_at", label: "Ad Creation Date" },
        // { key: "brand_name", label: "Brand" },
        // { key: "client_name", label: "Client" },
        { key: "creative_name", label: "Campaign Name" },
        // { key: "creative_start_date", label: "Start Date" },
        // { key: "creative_end_date", label: "End Date" },
        { key: "ad_creative_sub_type", label: "Ad Type" },
        // { key: "type", label: "Creative Type" },
        { key: "designer_name", label: "Assign to Designer" },
        { key: "content_writer_name", label: "Assign to Content Writer" },
        // { key: "content",label:"Content"},
        { key: "status", label: "Design Status" },
        { key: "action", label: "Action" },
    ],
    ready_to_live: [
        { key: "sales_person", label: "Sales Person Details" },
        { key: "created_at", label: "Ad Creation Date" },
        // { key: "brand_name", label: "Brand" },
        // { key: "client_name", label: "Client" },
        { key: "creative_name", label: "Campaign Name" },
        // { key: "creative_start_date", label: "Start Date" },
        // { key: "creative_end_date", label: "End Date" },
        { key: "ad_creative_sub_type", label: "Ad Type" },
        // { key: "type", label: "Creative Type" },
        { key: "designer_name", label: "Assign to Designer" },
        { key: "content_writer_name", label: "Assign to Content Writer" },
        // { key: "content",label:"Content"},
        { key: "status", label: "Design Status" },
        { key: "live_status", label: "Live" },
        { key: "action", label: "Action" },
    ],
    completed_ads: [
        { key: "sales_person", label: "Sales Person Details" },
        { key: "created_at", label: "Ad Creation Date" },
        // { key: "brand_name", label: "Brand" },
        // { key: "client_name", label: "Client" },
        // { key: "creative_name", label: "Campaign Name" },
        // { key: "creative_start_date", label: "Start Date" },
        { key: "order_details", label: "Order Details" },
        { key: "ad_creative_sub_type", label: "Ad Type" },
        // { key: "type", label: "Creative Type" },
        { key: "designer_name", label: "Assign to Designer" },
        // { key: "content",label:"Content"},
        { key: "status", label: "Design Status" },
        { key: "live_status", label: "Live" },
        { key: "action", label: "Action" },
    ],
};
